import { render, staticRenderFns } from "./ContractsForm.vue?vue&type=template&id=d4136372&scoped=true"
import script from "./ContractsForm.vue?vue&type=script&lang=js"
export * from "./ContractsForm.vue?vue&type=script&lang=js"
import style0 from "./ContractsForm.vue?vue&type=style&index=0&id=d4136372&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4136372",
  null
  
)

export default component.exports